<template>
  <div class="total-count__wrapper" :class="open ? 'open' : ''">
    <span v-if="open">{{ $t('attackSum.title') }}:</span>
    <v-icon v-else color="white">mdi-sigma</v-icon>
    <AnimatedNumber
      class="count"
      :value="totalAttacks"
      :duration="1000"
      :round="1"
      :formatValue="
        (value) => {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
      "
      easing="easeInOutExpo"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AnimatedNumber from 'animated-number-vue';
export default {
  name: 'TotalAttacks',
  props: {
    open: { type: Boolean, default: false }
  },
  components: {
    // WidgetWrapper,
    AnimatedNumber
  },
  computed: {
    ...mapGetters({ totalAttacks: 'eventStore/totalAttacks' })
  }
};
</script>

<style lang="scss" scoped>
.total-count__wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  .count {
    font-size: 1em;
    text-align: center;
    display: inline-block;
    // width: 100%;
    font-weight: 600;
    margin: 0 0 0 12px;
  }

  &.open {
    span {
      white-space: nowrap;
    }
    flex-direction: column;
  }
}
</style>
